import React ,{memo} from 'react';

const PercentageBar =memo(props=>{
  
    return <div className="percentage_bar" style={{width:`${props.percentage}%`}}></div>
})

export default PercentageBar;